import homeV2AssetManifest from "../data/homeV2AssetManifest.json";

export function homeV2Asset(path) {
  const assetPath = encodeURI(`${process.env.PUBLIC_URL || ""}/assets/home-v2/${path}`);
  const version = homeV2AssetManifest[path];

  return version ? `${assetPath}?v=${encodeURIComponent(version)}` : assetPath;
}
